import { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Snackbar,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { RUNNER_STATUS } from "../../../constants/global.constants";
import { axiosInstance } from "../../../services/api/api";
import { useResultsContext } from "../../../services/context/results-context";
import { LoaderMUI } from "../../../assets/global/loader/loader-mui";
import { AlertMessage } from "../../../assets/global/alert/alert-message";

// svg
import { ReactComponent as IconTooltip } from "../../../assets/svg/help-circle.svg";
import { ReactComponent as IconCopy } from "../../../assets/svg/copy.svg";
import { useUserContext } from "../../../services/context/user-context";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    /*   boxShadow: theme.shadows[1],
     fontSize: 11 */
  },
  /* cursor: 'pointer', */
}));

export const AdminRunnerItem = ({ runner, index }) => {
  
  const { runners, setRunners } = useResultsContext();

  const runnerStatus = runner.state;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getRunnerJson = async (runnerId) => {
    /*     try {
      const response = await axiosInstance.get(`/runner2/getJson/${runnerId}`);

      console.log(response, 'getJson');
    } catch (error) {
      // Handle error
      setError(error.response ? error.response.data.message : error.message);
    }  */

    setLoading(true);

    try {
      // GET request to fetch JSON data
      const getResponse = await axiosInstance.get(
        `/runner2/getJson/${runnerId}`
      );

      if (getResponse.data) {
        // POST request, sending the fetched JSON data
        const postResponse = await fetch(
          "https://scorpion-engaged-currently.ngrok-free.app/runner/create_property?results=5",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(getResponse.data),
          }
        );
      }
    } catch (error) {
      setError("Error in fetchThenPost:", error.statusText);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const sendJsonHandler = (e) => {
    e.stopPropagation();
    getRunnerJson(runner.id);
  };

  const adminTimings = runner.timings && JSON.parse(runner.timings);

  const [open, setOpen] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(`${runner?.id}`);
    setOpen(true);
  };

  return (
    <>
    <Snackbar
        message="Copied to clibboard"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={1000}
        onClose={() => setOpen(false)}
        open={open}
      />
      <Box sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}>
        <Typography fontSize={"8px"}>{runner?.id}</Typography>{" "}
        <IconButton
          onClick={handleCopy}
          sx={{padding: '4px'}}
        >
          <IconCopy
            stroke="#5d5f6a"
            /*  strokeWidth={"2px"} */
            width={"10px"}
            height={"10px"}
          />
        </IconButton>
      </Box>

      {runnerStatus === RUNNER_STATUS.FAILED && adminTimings ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            /* width: "100%",
                      position: "relative",
                      margin: "0 auto",
                      padding: '0px 16px 16px 16px' */
          }}
        >
          <Typography fontSize="8px">
            failedAt: {adminTimings.failedAt}
          </Typography>
          <LightTooltip
            title={`status: ${adminTimings.status}, msg: ${adminTimings.errormsg}`}
            placement="right"
          >
            <IconTooltip width="10px" height="10px" stroke="#BA1A1A" />
          </LightTooltip>
        </Box>
      ) : adminTimings && adminTimings.execution_times ? (
        <>
          <Typography fontSize={"8px"}>
            pipeline: {adminTimings.execution_times.pipeline}
          </Typography>
          <Typography fontSize={"8px"}>
            process_inputs: {adminTimings.execution_times.process_inputs}
          </Typography>
        </>
      ) : null}

      <Button
        onClick={sendJsonHandler}
        size="small"
        sx={{
          /* width: "100%", */
          background: "#EFA21E",
          color: "#fff",
          textTransform: "none",
          boxShadow: 2,
          fontSize: "10px",
          ":hover": {
            boxShadow: 4,
          },
        }}
      >
        Send JSON
      </Button>

      {/* Loader */}
      {loading && <LoaderMUI withBackdrop={true} />}

      {/* Error Alert */}
      {error && <AlertMessage message={error} type="error" />}
    </>
  );
};
